import { configureStore, createSlice } from "@reduxjs/toolkit";

const postPageSlice = createSlice({
  name: "counter",
  initialState: {
    flatlistVisibleElement:{},    
    actualUser:{},
    userReferrals:[],
    piPrice:1,
    supportedCryptos:[],
    stakes:[],
    recentUsersIInteractedWith:[],
    // Contest state
    dailyContestants:[],
    contestWinners:[],
    isInTodayContest: false,
  },
  reducers: {
    updateFlatlistVisibleElement(state, action) {
      state.flatlistVisibleElement[action.payload?.class][action.payload?.pageKey] =
        action.payload?.item;
    },
    setActualUser(state,action){
      state.actualUser = action.payload
    },
    resetStore(state,action){
      state.actualUser = undefined
      state.flatlistVisibleElement=undefined
    },
    setUserReferrals(state,action){
      state.userReferrals = action.payload
    },
    setPiCryptoPrice(state,action){
      state.piPrice = action.payload
    },
    setSupportedCryptos(state,action){
      state.supportedCryptos = action.payload
    },
    setStakes(state,action){
      state.stakes = action.payload
    },
    setRecentUsersIInteractedWith(state,action){
      state.recentUsersIInteractedWith = action.payload
    },
    // Contest reducers
    setDailyContestants(state, action) {
      state.dailyContestants = action.payload;
    },
    setContestWinners(state, action) {
      state.contestWinners = action.payload;
    },
    setIsInTodayContest(state, action) {
      state.isInTodayContest = action.payload;
    },
  },
});

export const actions = postPageSlice.actions;

const store = configureStore({
  reducer: postPageSlice.reducer,
});
export default store;

